/**
 * Catalogo completo delle domande del questionario ESG
 * Ogni domanda ha una questionKey stabile che non dipende dall'ordine
 */

export const QUESTIONS = {
  // ========== SEZIONE 1: COMPANY INFORMATION ==========
  q01_company_name: {
    key: "q01_company_name",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Company Name",
    type: "text",
    placeholder: "Company Name",
    required: true,
    requiresFile: false,
  },
  q02_legal_name: {
    key: "q02_legal_name",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Legal Entity Name",
    type: "text",
    placeholder: "Legal Entity Name",
    required: true,
    requiresFile: false,
  },
  q03_tax_id: {
    key: "q03_tax_id",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Tax ID / VAT",
    type: "text",
    placeholder: "Tax ID / VAT",
    required: true,
    requiresFile: false,
  },
  q04_head_office: {
    key: "q04_head_office",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Headquarters Address",
    type: "text",
    placeholder: "Headquarters Address",
    required: true,
    requiresFile: false,
  },
  q05_esg_contact: {
    key: "q05_esg_contact",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "ESG Contact Name & Role",
    type: "text",
    placeholder: "ESG Contact Name & Role",
    required: true,
    requiresFile: false,
  },
  q06_email: {
    key: "q06_email",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Email",
    type: "email",
    placeholder: "Email",
    required: true,
    requiresFile: false,
  },
  q07_phone: {
    key: "q07_phone",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Phone",
    type: "tel",
    placeholder: "Phone",
    required: false,
    requiresFile: false,
  },
  q08_sector: {
    key: "q08_sector",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Business Sector",
    type: "text",
    placeholder: "Business Sector",
    required: true,
    requiresFile: false,
  },
  q09_employees: {
    key: "q09_employees",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Number of Employees",
    type: "number",
    placeholder: "Number of Employees",
    required: true,
    requiresFile: false,
  },
  q10_revenue: {
    key: "q10_revenue",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Annual Revenue (optional)",
    type: "text",
    placeholder: "Annual Revenue",
    required: false,
    requiresFile: false,
  },
  q11_website: {
    key: "q11_website",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Company Website",
    type: "url",
    placeholder: "Company Website",
    required: false,
    requiresFile: false,
  },
  q11_company_logo: {
    key: "q11_company_logo",
    section: "company_info",
    sectionTitle: "Company Information",
    label: "Upload Company Logo",
    type: "file",
    placeholder: "Company Logo",
    required: false,
    requiresFile: true,
    fileType: "image",
    description: "Upload your company logo (JPG, PNG, SVG - max 5MB)",
  },

  // ========== SEZIONE 2: ENVIRONMENTAL ==========
  q13_renewable_energy: {
    key: "q13_renewable_energy",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you use renewable energy?",
    type: "select",
    required: true,
    requiresFile: false,
    options: [
      { value: "", label: "-- Select --" },
      { value: "yes_100", label: "Yes, 100%" },
      { value: "partial", label: "Partial (specify in notes)" },
      { value: "no", label: "No" },
    ],
  },
  q14_renewable_percentage: {
    key: "q14_renewable_percentage",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "What percentage of your energy comes from renewable sources?",
    type: "text",
    placeholder: "e.g., 60%",
    required: false,
    requiresFile: true,
  },
  q15_energy_certified: {
    key: "q15_energy_certified",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Is your facility energy certified?",
    type: "select",
    required: false,
    requiresFile: true,
    options: [
      { value: "", label: "-- Select --" },
      { value: "yes", label: "Yes" },
      { value: "in_progress", label: "In Progress" },
      { value: "no", label: "No" },
    ],
  },
  q16_carbon_plan: {
    key: "q16_carbon_plan",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you have a carbon footprint reduction plan?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q17_waste_management: {
    key: "q17_waste_management",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you recycle materials and manage waste sustainably?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q18_no_plastics: {
    key: "q18_no_plastics",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Have you eliminated single-use plastics?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q19_water_conservation: {
    key: "q19_water_conservation",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you have water conservation initiatives?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q20_biodiversity: {
    key: "q20_biodiversity",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you have biodiversity protection programs?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q21_emissions_monitoring: {
    key: "q21_emissions_monitoring",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you monitor and report GHG emissions (Scope 1, 2, 3)?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q22_green_transport: {
    key: "q22_green_transport",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you encourage sustainable transport for employees?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q23_circular_economy: {
    key: "q23_circular_economy",
    section: "environmental",
    sectionTitle: "Environmental",
    label: "Do you implement circular economy principles?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },

  // ========== SEZIONE 3: SOCIAL ==========
  q24_flex_work: {
    key: "q24_flex_work",
    section: "social",
    sectionTitle: "Social",
    label: "Do you provide flexible working arrangements?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q25_diversity_policy: {
    key: "q25_diversity_policy",
    section: "social",
    sectionTitle: "Social",
    label: "Do you have a diversity and inclusion policy?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q26_percent_women: {
    key: "q26_percent_women",
    section: "social",
    sectionTitle: "Social",
    label: "Percentage of women in the company",
    type: "text",
    placeholder: "e.g., 45%",
    required: false,
    requiresFile: true,
  },
  q27_percent_disabilities: {
    key: "q27_percent_disabilities",
    section: "social",
    sectionTitle: "Social",
    label: "Percentage of employees with disabilities",
    type: "text",
    placeholder: "e.g., 5%",
    required: false,
    requiresFile: true,
  },
  q28_percent_women_leaders: {
    key: "q28_percent_women_leaders",
    section: "social",
    sectionTitle: "Social",
    label: "Percentage of women in leadership roles",
    type: "text",
    placeholder: "e.g., 20%",
    required: false,
    requiresFile: true,
  },
  q29_training: {
    key: "q29_training",
    section: "social",
    sectionTitle: "Social",
    label: "Do you offer employee training and development?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q30_social_partners: {
    key: "q30_social_partners",
    section: "social",
    sectionTitle: "Social",
    label: "Do you work with social cooperatives or ethical suppliers?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q31_supplier_esg: {
    key: "q31_supplier_esg",
    section: "social",
    sectionTitle: "Social",
    label: "Do you verify that your suppliers follow ESG standards?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q32_health_safety: {
    key: "q32_health_safety",
    section: "social",
    sectionTitle: "Social",
    label: "Do you have health and safety programs for workers?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q33_community_engagement: {
    key: "q33_community_engagement",
    section: "social",
    sectionTitle: "Social",
    label: "Do you engage with local communities?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q34_fair_wages: {
    key: "q34_fair_wages",
    section: "social",
    sectionTitle: "Social",
    label: "Do you guarantee fair wages and benefits?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q35_human_rights: {
    key: "q35_human_rights",
    section: "social",
    sectionTitle: "Social",
    label: "Do you have a human rights policy?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },

  // ========== SEZIONE 4: GOVERNANCE ==========
  q36_sustainability_report: {
    key: "q36_sustainability_report",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you publish a sustainability or ESG report?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q37_esg_team: {
    key: "q37_esg_team",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you have a dedicated ESG team or contact?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q38_ethics_code: {
    key: "q38_ethics_code",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you have a public code of ethics?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q39_audits: {
    key: "q39_audits",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you perform internal or external audits (e.g., ISO, SA8000)?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q40_anti_corruption: {
    key: "q40_anti_corruption",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you have an anti-corruption plan?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q41_whistleblowing: {
    key: "q41_whistleblowing",
    section: "governance",
    sectionTitle: "Governance",
    label: "How do you handle whistleblowing reports?",
    type: "text",
    placeholder: "Describe your process",
    required: false,
    requiresFile: true,
  },
  q42_board_diversity: {
    key: "q42_board_diversity",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you have board diversity policies?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q43_risk_management: {
    key: "q43_risk_management",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you have ESG risk management processes?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q44_stakeholder_engagement: {
    key: "q44_stakeholder_engagement",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you actively engage with stakeholders on ESG topics?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },
  q45_data_privacy: {
    key: "q45_data_privacy",
    section: "governance",
    sectionTitle: "Governance",
    label: "Do you comply with data privacy regulations (GDPR, etc.)?",
    type: "checkbox",
    required: false,
    requiresFile: true,
  },

  // ========== SEZIONE 5: FINAL DECLARATION ==========
  q46_accept_terms: {
    key: "q46_accept_terms",
    section: "declaration",
    sectionTitle: "Final Declaration",
    label: "I accept the terms of the questionnaire",
    type: "checkbox",
    required: true,
    requiresFile: false,
  },
  q47_data_accuracy: {
    key: "q47_data_accuracy",
    section: "declaration",
    sectionTitle: "Final Declaration",
    label: "I declare that the data provided is accurate",
    type: "checkbox",
    required: true,
    requiresFile: false,
  },
};

/**
 * Ottiene tutte le domande in ordine
 */
export function getQuestions() {
  return Object.values(QUESTIONS);
}

/**
 * Ottiene le domande raggruppate per sezione
 */
export function getQuestionsBySection() {
  const sections = {};
  
  Object.values(QUESTIONS).forEach((q) => {
    if (!sections[q.section]) {
      sections[q.section] = {
        section: q.section,
        title: q.sectionTitle,
        questions: [],
      };
    }
    sections[q.section].questions.push(q);
  });

  return sections;
}

/**
 * Ottiene le domande che richiedono file
 */
export function getQuestionsRequiringFiles() {
  return Object.values(QUESTIONS).filter((q) => q.requiresFile);
}

/**
 * Valida le risposte del questionario
 * @param {object} answers - Oggetto con le risposte { questionKey: value }
 * @param {object} attachments - Oggetto con gli allegati { questionKey: attachmentData }
 * @returns {object} { isValid: boolean, errors: string[] }
 */
export function validateAnswers(answers, attachments) {
  const errors = [];
  
  Object.values(QUESTIONS).forEach((q) => {
    const answer = answers[q.key];
    
    // Controlla campi required
    if (q.required) {
      if (q.type === "checkbox") {
        if (!answer || answer === false) {
          errors.push(`${q.label} is required`);
        }
      } else {
        if (!answer || (typeof answer === "string" && !answer.trim())) {
          errors.push(`${q.label} is required`);
        }
      }
    }
    
    // Controlla file required
    if (q.requiresFile && q.required) {
      if (!attachments[q.key]) {
        errors.push(`${q.label} requires an attachment`);
      }
    }
  });
  
  return {
    isValid: errors.length === 0,
    errors,
  };
}

/**
 * File types consentiti
 */
export const ALLOWED_FILE_TYPES = {
  "application/pdf": ".pdf",
  "image/jpeg": ".jpg,.jpeg",
  "image/png": ".png",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
};

/**
 * File types per immagini (logo)
 */
export const ALLOWED_IMAGE_TYPES = {
  "image/jpeg": ".jpg,.jpeg",
  "image/png": ".png",
  "image/svg+xml": ".svg",
};

/**
 * Dimensione massima file (20MB)
 */
export const MAX_FILE_SIZE = 20 * 1024 * 1024;

/**
 * Dimensione massima per immagini (5MB)
 */
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

/**
 * Valida un file
 * @param {File} file - File da validare
 * @returns {object} { isValid: boolean, error: string }
 */
export function validateFile(file) {
  if (!file) {
    return { isValid: false, error: "No file selected" };
  }

  // Controlla dimensione
  if (file.size > MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: `File size exceeds 20MB (${(file.size / 1024 / 1024).toFixed(2)}MB)`,
    };
  }

  // Controlla tipo
  if (!ALLOWED_FILE_TYPES[file.type]) {
    return {
      isValid: false,
      error: `File type not allowed. Allowed: PDF, JPG, PNG, DOCX, XLSX`,
    };
  }

  return { isValid: true, error: null };
}

/**
 * Valida un file immagine (per logo)
 * @param {File} file - File da validare
 * @returns {object} { isValid: boolean, error: string }
 */
export function validateImageFile(file) {
  if (!file) {
    return { isValid: false, error: "No file selected" };
  }

  // Controlla dimensione
  if (file.size > MAX_IMAGE_SIZE) {
    return {
      isValid: false,
      error: `File size exceeds 5MB (${(file.size / 1024 / 1024).toFixed(2)}MB)`,
    };
  }

  // Controlla tipo
  if (!ALLOWED_IMAGE_TYPES[file.type]) {
    return {
      isValid: false,
      error: `File type not allowed. Allowed: JPG, PNG, SVG`,
    };
  }

  return { isValid: true, error: null };
}
